// Return unix timestamp.
const timestamp = (inMilliseconds) => {
  if (inMilliseconds) {
    return +new Date();
  }
  return Math.round(+new Date() / 1000);
};
export default timestamp;
